/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useDispatch} from "useDispatch";
import {useTranslation} from "react-i18next";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import clsx from "clsx";
import {PlusIcon} from "@heroicons/react/24/solid";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import ButtonSubmit from "pages/Front/Booking/components/ButtonSubmit";
import * as yup from "yup";
import {Reservation} from "types/entities/Reservation";
import {ThunkAction} from "model/store/thunk";
import BookingAction from "store/booking/BookingAction";
import {useTypedSelector} from "helpers/reducers";
import CompanyFormLabel from "pages/Front/Booking/components/CompanyForm/CompanyFormLabel";
import T from "components/T";
import {closeModal} from "helpers/actions";
import {toast} from "react-toastify";
import {consoleLog} from "utils/utility";
import ModalScrollableClose from "components/ModalScrollableClose";
import SellerAction from "store/seller/SellerAction";

interface NoteFormInputs {
    reservation_note: string;
}

interface BookingSellerNotesAddFormModalProps {
    reservation: Reservation;
    replied_note_id?: number | null;
}

const BookingSellerNotesAddFormModal = (props: BookingSellerNotesAddFormModalProps) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const packagesCart = useTypedSelector(state => state.bookingState.bookingProcess.packageCart);
    const defaultValues = {
        reservation_note: "",
    };

    const formScheme = yup.object().shape({
        reservation_note: yup.string().required(),
    });

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
    } = useForm<NoteFormInputs>({
        defaultValues: defaultValues,
        resolver: yupResolver(formScheme),
    });

    // const onSubmittedCompanyHandler = (company: Company) => {
    //     dispatch(BookingAction.fetchEditCustomer(company)).then(r => {
    //         toast.success(t("Company updated"));
    //     });
    // };

    const onErrorHandler = (data: any) => {
        consoleLog("onErrorHandler", data);
    };

    const onSubmitHandler = (data: any) => {
        if (props.reservation?.packagesCart && data.reservation_note) {
            dispatch<ThunkAction<any, any>>(BookingAction.sendReservationNote(props.reservation.packagesCart, data.reservation_note, props?.replied_note_id ? props.replied_note_id : null)).then(r => {
                dispatch(SellerAction.pushReservationNote(r.reservationNote));
                toast.success("Note added to offer.");
                dispatch(closeModal());
            });
        }
    };

    return (
        <CardComponent
            className={"BookingSellerNotesAddFormModal my-auto w-full md:min-w-[500px] max-w-[900px] !p-0 border border-gray-200 relative"}>
            <div
                className={
                    "top-0 z-30 sticky flex flex-row justify-between rounded-tl-lg rounded-tr-lg w-full px-3 py-3 font-bold border-b-2 border-gray-200 bg-gray-50 text-gray-900 drop-shadow-sm"
                }
            >
                <div className={"flex flex-row items-center"}>
                    <PlusIcon className={clsx("w-5 h-5 mr-1 text-gray-600/70 drop-shadow-xl")} />
                    <h4 className={"font-medium text-gray-700"}>{t("Add note")}</h4>
                </div>
                <ModalScrollableClose />
            </div>
            <div
                className={"flex w-full flex-col px-3 pt-3 pb-4 bg-gray-50 overflow-hidden h-auto rounded-bl-lg rounded-br-lg"}>
                <div className={"flex overflow-y-auto h-full w-full"}>
                    <form className={"flex flex-col space-y-6 w-full"}
                          onSubmit={handleSubmit(onSubmitHandler, onErrorHandler)}>
                        <CardComponent>
                            <div className={"BookingReservationNoteTitle mb-2"}>
                                <h3 className={"font-bold"}>{t("Send us a note")}</h3>
                            </div>
                            <CompanyFormLabel errors={errors} label={t("Note")} name={"reservation_note"}
                                              required={true} />
                            <textarea
                                className={"p-2 w-full border-gray-500 border rounded text-base font-medium min-h-[120px]"}
                                {...register("reservation_note")}
                            />
                            {errors?.["reservation_note"]?.message && (
                                <div className={"text-red-500 text-sm mt-1 flex flex-row"}>
                                    <T>{errors?.["reservation_note"]?.message}</T>
                                </div>
                            )}
                        </CardComponent>

                        <ButtonSubmit
                            className={clsx(
                                "SellerCustomerCreate",
                                "inline-flex items-center px-4 sm:px-3 py-3 w-auto rounded-md sm:min-w-[210px] !font-medium !text-base sm:!text-lg sm:!leading-none",
                                "bg-cta-400",
                            )}
                            icon={"check"}
                            label={t("Add note")}
                            onClick={handleSubmit(onSubmitHandler, onErrorHandler)}
                            type={"submit"}
                        />
                    </form>
                    {/*<SellerCompanyForm*/}
                    {/*    company={props.reservation?.company ? props.reservation.company : undefined}*/}
                    {/*    editEnabled={true}*/}
                    {/*    onSubmitted={onSubmittedCompanyHandler}*/}
                    {/*/>*/}
                </div>
            </div>
        </CardComponent>
    );
};

export default BookingSellerNotesAddFormModal;
